import { createApp } from "vue";
import App from "./App.vue";
import axios from "axios";
import VueAxios from "vue-axios";
import router from "./router/index";
import store from "./store/index";
import vuetify from "./plugins/vuetify";
import { loadTranslations } from "./functions/translation.js";

const app = createApp(App);
app.config.globalProperties.$translations = {
  // t,
  loadTranslations,
};
app.use(vuetify).use(VueAxios, axios).use(router).use(store)

loadTranslations(store.state.locale).then(() => {
  app.mount("#app");
});
